import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
const configData = require('../../config.json');

const FileDefinitionForm = () => {
    const initialFormData = {
        fileName: '',
        fileType: '',
        fileFormat: '',
        frequency: '',
        frequencyDetails: '',
        organization: '',
        emails: [''],
        groupEmails: '',
        verifiedFilePath: '',
        failedFilePath: ''
    };
    const initialFields = [{ fieldName: '', fieldType: '' }];
    const [formData, setFormData] = useState(initialFormData);
    const [fields, setFields] = useState(initialFields);
    const [jsonData, setJsonData] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [fileTypes, setFileTypes] = useState([]);
    const [groupEmails, setGroupEmails] = useState([]);
    const [emailErrors, setEmailErrors] = useState([]);
    const [loading, setLoading] = useState(true);
    const fileFormats = ['csv', 'xlsx'];

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    fetchFiles(),
                    fetchOrganizations(),
                    // fetchFileTypes(),
                    // fetchGroupEmails()
                ]);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []); // Fetch dependencies only once

    useEffect(() => {
        validateEmails();
    }, [formData.emails]);

    const fetchFiles = async () => {
        try {
            const response = await axios.get(configData.FILEVALIDATION_URL+'get_formats', {
                params: { OrganizationName: formData.organization }
            });
            setJsonData(response.data);
        } catch (error) {
            console.error('Error fetching files:', error);
            toast.error('Failed to fetch saved files.');
        }
    };

    const fetchOrganizations = async () => {
        try {
            const response = await axios.get(configData.FILEVALIDATION_URL+'get_organizations');
            setOrganizations(response.data);
        } catch (error) {
            console.error('Error fetching organizations:', error);
            toast.error('Failed to fetch organizations.');
        }
    };

    const fetchFileTypes = async (organization) => {
        try {
            
            const response = await axios.get(configData.FILEVALIDATION_URL+'get_filetypes', {
                params: {Organization: organization }
            })
           
            // const response = await fetch(configData.SERVER_URL + 'fincorp_getFileTypes');
            
            // toast.error('retreived: ' + response.data);
            setFileTypes(response.data);
            
        } catch (e) {
            toast.error('Error fetching file types:'+ e);
            // toast.error('Failed to fetch file types.');
        }
    };

    const fetchVerifiedAndFailedPathLocationsByOrgNameAndFileType = async (organization, value) => {
        
        try {

            // API Call to get org id from name
            
            /*
            const response = await axios.get('http://localhost:3030/api/fincorp_getLookupValueBasedOnOrgIdAndObjectType', {
                params: { orgid: '605b29d9d89c78762deefe78', object_type: 'Inventory' }
            });*/

            const response = await axios.get(configData.FILEVALIDATION_URL+'get_getLookupValuesBasedOnOrgAndFileType', {
                params: { Organization: organization, fileType: value }
            })
           
            // const response = await fetch('http://localhost:3030/api/fincorp_getLookupValueBasedOnOrgIdAndObjectType');
            const result = response.data;

            if(result[0] === "N/A"){
                toast.error("\"Verified Files Directory\" Lookup Value has not been set up for this File Type");
            }
            if(result[1] === "N/A"){
                toast.error("\"Failed Files Direcotry\" Lookup Value has not been set up for this File Type");
            }
            
            if(result[0] !== "N/A" && result[1] !== "N/A"){
                setFormData({
                    ...formData,
                    fileType: value,
                    verifiedFilePath: result[0],
                    failedFilePath: result[1]
                });
                // Set file path to response
                // toast.error("VerifiedFilePath: "+ result[0]);
                // toast.error("FailedFilePath: "+ result[1]);
            }
            
        } catch (e) {
            console.error('Error fetching lookup value:', e);
            
            toast.error('Failed to fetch lookup value.'+ e);
        }
    };

    

    const fetchGroupEmails = async (organization) => {
        try {
            const response = await axios.get(configData.FILEVALIDATION_URL+'get_groupemailnames',{
                params : {Organization:organization}
            });
            setGroupEmails(response.data);
        } catch (error) {
            console.error('Error fetching group emails:', error);
            toast.error('Failed to fetch group emails.');
        }
    };

    const handleChange = (e, index) => {
        const { name, value } = e.target;
        if (name === 'organization') {
            setFormData({
                ...formData,
                [name]: value,
                fileType: ''
            });
            fetchFileTypes(value);
            // fetchGroupEmails(value);
            
        } else if (name === 'fileType'){
            fetchVerifiedAndFailedPathLocationsByOrgNameAndFileType(formData.organization, value);
            
            
        }else if (name in formData && name !== 'emails') {
            setFormData({
                ...formData,
                [name]: value,
            });
        } else if (name === 'emails') {
            const updatedEmails = [...formData.emails];
            updatedEmails[index] = value;
            setFormData({
                ...formData,
                emails: updatedEmails,
            });
        } else {
            // toast.error('this else statement is useless')
            const updatedFields = [...fields];
            updatedFields[index][name] = value;
            setFields(updatedFields);
        }
    };

    const addField = () => {
        setFields([...fields, { fieldName: '', fieldType: '' }]);
    };

    const removeField = (index) => {
        const updatedFields = [...fields];
        updatedFields.splice(index, 1);
        setFields(updatedFields);
    };

    const addEmailField = () => {
        setFormData({
            ...formData,
            emails: [...formData.emails, '']
        });
    };

    const removeEmailField = (index) => {
        const updatedEmails = [...formData.emails];
        updatedEmails.splice(index, 1);
        setFormData({
            ...formData,
            emails: updatedEmails,
        });
    };

    const validateEmails = () => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const errors = formData.emails.map((email, index) => {
            if (!emailPattern.test(email)) {
                return `Email ${index + 1} is invalid.`;
            }
            if (formData.emails.indexOf(email) !== index) {
                return `Email ${index + 1} is a duplicate.`;
            }
            return null;
        });
        setEmailErrors(errors);
    };

    const validateForm = () => {
        if (!formData.fileName || !formData.fileType || !formData.organization || !formData.frequency) {
            toast.error('Please fill out all required fields.');
            return false;
        }
        for (const field of fields) {
            if (!field.fieldName || !field.fieldType) {
                toast.error('Please fill out all field details.');
                return false;
            }
        }
        if (emailErrors.some(error => error !== null)) {
            toast.error('Please resolve email validation errors.');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        const formattedData = {
            ...formData,
            fields: fields.map((field) => ({
                fieldName: field.fieldName,
                fieldType: field.fieldType,
            })),
        };
        try {
            await axios.post(configData.FILEVALIDATION_URL+'add_format', formattedData);
            // toast.error("this is the verifiedFilePath:"+formData.verifiedFilePath);
            toast.success('File format saved successfully!');
            
            fetchFiles(); // Fetch updated JSON data after successful save
            clearForm();
        } catch (error) {
            console.error('Error saving the file format', error);
            toast.error('Failed to save file format. Please try again.');
        }
    };

    const clearForm = () => {
        setFormData(initialFormData);
        setFields(initialFields);
    };

    /*
    const renderNewFileType = () => {
        switch(formData.fileType){
            case 'Create new file type':
                return (
                    <div className="form-group mb-2">
                        <input 
                            list="fileTypes"
                            className="form-control" 
                            name="fileType" 
                            value={formData.fileType} 
                            onChange={handleChange} 
                            placeholder="Name the new File Type"
                        ></input>
                    </div>
                );
            default:
                return null;
        }
    }
    */

    const renderFrequencyInput = () => {
        switch (formData.frequency) {
            case 'Daily':
                return null; // No additional input needed for daily frequency
            case 'Weekly':
                return (
                    <div className="form-group mb-2">
                        <label>Select Days of the Week:</label>
                        <select
                            className="form-control"
                            multiple
                            value={formData.frequencyDetails.split(':')}
                            onChange={(e) => setFormData({ ...formData, frequencyDetails: [...e.target.selectedOptions].map(option => option.value).join(':') })}
                        >
                            <option value="Sunday">Sunday</option>
                            <option value="Monday">Monday</option>
                            <option value="Tuesday">Tuesday</option>
                            <option value="Wednesday">Wednesday</option>
                            <option value="Thursday">Thursday</option>
                            <option value="Friday">Friday</option>
                            <option value="Saturday">Saturday</option>
                        </select>
                    </div>
                );
            case 'Monthly':
                return (
                    <div className="form-group mb-2">
                        <label>Select Days of the Month:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={formData.frequencyDetails}
                            onChange={(e) => setFormData({ ...formData, frequencyDetails: e.target.value })}
                            placeholder="Enter days separated by commas, e.g., 12, 17, 29"
                        />
                    </div>
                );
            case 'Quarterly':
                return (
                    <div className="form-group mb-2">
                        <label>Select Quarterly Option:</label>
                        <select
                            className="form-control"
                            value={formData.frequencyDetails}
                            onChange={(e) => setFormData({ ...formData, frequencyDetails: e.target.value })}
                        >
                            <option value="">Select Option</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                        </select>
                    </div>
                );
            case 'Semiannually':
                return (
                    <div className="form-group mb-2">
                        <label>Select Months:</label>
                        <select
                            className="form-control"
                            multiple
                            value={formData.frequencyDetails.split(':')}
                            onChange={(e) => setFormData({ ...formData, frequencyDetails: [...e.target.selectedOptions].map(option => option.value).join(':') })}
                        >
                            <option value="January">January</option>
                            <option value="February">February</option>
                            <option value="March">March</option>
                            <option value="April">April</option>
                            <option value="May">May</option>
                            <option value="June">June</option>
                            <option value="July">July</option>
                            <option value="August">August</option>
                            <option value="September">September</option>
                            <option value="October">October</option>
                            <option value="November">November</option>
                            <option value="December">December</option>
                        </select>
                    </div>
                );
            case 'Yearly':
                return (
                    <div className="form-group mb-2">
                        <label>Select Month:</label>
                        <select
                            className="form-control"
                            value={formData.frequencyDetails}
                            onChange={(e) => setFormData({ ...formData, frequencyDetails: e.target.value })}
                        >
                            <option value="">Select Month</option>
                            <option value="January">January</option>
                            <option value="February">February</option>
                            <option value="March">March</option>
                            <option value="April">April</option>
                            <option value="May">May</option>
                            <option value="June">June</option>
                            <option value="July">July</option>
                            <option value="August">August</option>
                            <option value="September">September</option>
                            <option value="October">October</option>
                            <option value="November">November</option>
                            <option value="December">December</option>
                        </select>
                    </div>
                );
            default:
                return null;
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="card mt-5 p-4">
                        <h2 className="my-4 text-center">File Structure Specification</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group mb-2">
                                <label>Organization:</label>
                                <select
                                    className="form-control"
                                    name="organization"
                                    value={formData.organization}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Organization</option>
                                    {organizations.map((org) => (
                                        <option key={org[1]} value={org[1]}>
                                            {org[0]}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group mb-2">
                                <label>File Structure Name:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="fileName"
                                    value={formData.fileName}
                                    onChange={(e) => setFormData({ ...formData, fileName: e.target.value })}
                                    disabled={!formData.organization}
                                />
                            </div>
                            <div className="form-group mb-2">
                                <label>File Type:</label>
                                <select
                                    className="form-control"
                                    name="fileType"
                                    value={formData.fileType}
                                    onChange={handleChange}
                                    disabled={!formData.organization}
                                >
                                    <option value="">Select File Type</option>
                                    {fileTypes.map((type) => (
                                        <option key={type} value={type}>
                                            {type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            

                        
                            <div className="form-group mb-2">
                                <label>File Format:</label>
                                <select
                                    className="form-control"
                                    name="fileFormat"
                                    value={formData.fileFormat}
                                    onChange={(e) => setFormData({ ...formData, fileFormat: e.target.value })}
                                    disabled={!formData.organization}
                                >
                                    <option value="">Select File Format</option>
                                    {fileFormats.map((format) => (
                                        <option key={format} value={format}>
                                            {format}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group mb-2">
                                <label>Frequency:</label>
                                <select
                                    className="form-control"
                                    name="frequency"
                                    value={formData.frequency}
                                    onChange={(e) => setFormData({ ...formData, frequency: e.target.value })}
                                    disabled={!formData.organization}
                                >
                                    <option value="">Select Frequency</option>
                                    <option value="Daily">Daily</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Quarterly">Quarterly</option>
                                    <option value="Semiannually">Semiannually</option>
                                    <option value="Yearly">Yearly</option>
                                </select>
                            </div>
                            {renderFrequencyInput()}
                            {/*< div className="form-group mb-2">
                                <label>Group Emails:</label>
                                <select
                                    className="form-control"
                                    name="groupEmails"
                                    value={formData.groupEmails}
                                    onChange={handleChange}
                                    disabled={!formData.organization}
                                >
                                    <option value="">Select Group Emails</option>
                                    {groupEmails.map((group) => (
                                        <option key={group} value={group}>
                                            {group}
                                        </option>
                                    ))}
                                </select>
                            </div> */}
                            <div className="form-group mb-2">
                                <label>Emails:</label>
                                {formData.emails.map((email, index) => (
                                    <div key={index} className="d-flex mb-2">
                                        <input
                                            type="email"
                                            className={`form-control ${emailErrors[index] ? 'is-invalid' : ''}`}
                                            value={email}
                                            onChange={(e) => handleChange(e, index)}
                                            name="emails"
                                            disabled={!formData.organization}
                                        />
                                        {index > 0 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger ml-2"
                                                onClick={() => removeEmailField(index)}
                                            >
                                                Remove
                                            </button>
                                        )}
                                        {emailErrors[index] && (
                                            <div className="invalid-feedback">
                                                {emailErrors[index]}
                                            </div>
                                        )}
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={addEmailField}
                                    disabled={!formData.organization}
                                >
                                    Add Email
                                </button>
                            </div>
                            <div className="d-flex justify-content-end mt-4 mb-2">
                                <button type="button" className="btn btn-primary" onClick={addField} disabled={!formData.organization}>
                                    Add Field
                                </button>
                            </div>
                            <h4 className="mt-4 mb-3">Add Columns:</h4>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Column Name</th>
                                        <th>Column Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fields.map((field, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Column Name"
                                                    value={field.fieldName}
                                                    onChange={(e) => handleChange(e, index)}
                                                    name="fieldName"
                                                    disabled={!formData.organization}
                                                />
                                            </td>
                                            <td>
                                                <select
                                                    className="form-control"
                                                    value={field.fieldType}
                                                    onChange={(e) => handleChange(e, index)}
                                                    name="fieldType"
                                                    disabled={!formData.organization}
                                                >
                                                    <option value="">Select Type</option>
                                                    <option value="Text">Text</option>
                                                    <option value="Int">Number</option>
                                                    <option value="StandardDate">Date</option>
                                                    <option value="MoneyFloat">MoneyFloat</option>
                                                </select>
                                            </td>
                                            <td>
                                                {index > 0 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => removeField(index)}
                                                        disabled={!formData.organization}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="d-flex justify-content-end mt-4">
                                <button type="submit" className="btn btn-success mr-10" style={{ marginRight: "10px" }} disabled={!formData.organization}>
                                    Save
                                </button>
                                <button type="button" className="btn btn-secondary ml-5" onClick={clearForm}>
                                    Clear
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            <ToastContainer />
        </div>
    );
};

export default FileDefinitionForm;
